import { closestCenter, DndContext, PointerSensor, useSensor, useSensors } from '@dnd-kit/core'
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable'

import SortablePackagingListSkeleton from './SortablePackagingListSkeleton/SortablePackagingListSkeleton'
import SortablePackagingItem from './SortablePackagingItem'

const SortablePackagingList = ({
  packagingItems,
  onChangeEnabled,
  onDelete,
  onEdit,
  onDuplicate,
  onSetDefault,
  dragging,
  onSortEnd,
  onSortStart,
  loading,
  isEditable,
}) => {
  const sensors = useSensors(useSensor(PointerSensor))

  if (loading) {
    return <SortablePackagingListSkeleton />
  }

  return (
    <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={onSortEnd} onDragStart={onSortStart}>
      <SortableContext items={packagingItems} strategy={verticalListSortingStrategy}>
        <div>
          {packagingItems.map((packagingItem, index) => (
            <SortablePackagingItem
              key={packagingItem?.id}
              data={packagingItem}
              onEdit={onEdit}
              onDelete={onDelete}
              onDuplicate={onDuplicate}
              onSetDefault={onSetDefault}
              onChangeEnabled={onChangeEnabled}
              index={index}
              position={index}
              dragging={dragging}
              isEditable={isEditable}
            />
          ))}
        </div>
      </SortableContext>
    </DndContext>
  )
}

export default SortablePackagingList
